<template>
    <div class="home-section-container">
            <p class="home-section-header">{{ header }}</p>
            <slot></slot>
            <!-- <hr class="home-section-divider"> -->
            <div class="home-section-footer">
                <button v-if="footer_action_type == 0" class="button" @click="onButtonClick">{{ footer_action_text }}</button>
                <a v-else href="javascript:void(0)" @click="onButtonClick">{{ footer_action_text }}</a>
            </div>
        </div>
</template>
<script>
export default {
    props: {
        header: {
            type: String,
            required: true
        },
        footer_action_text: {
            type: String,
            required: false,
            default: () => { return "Let's go"}
        },
        footer_action_type: {
            type: Number,
            required: false,
            default: () => { return 0 },
            validation: (val) => { val == 0 || val == 1 ? true : false },
        },
        footer_action: {
            type: Function,
            required: true
        }
    },
    computed: {
    },
    methods: {
        onButtonClick() {
            if (this.footer_action && typeof this.footer_action == 'function') {
                this.footer_action()
            } 
            this.$emit('click')
        }
    }
}
</script>
<style>
.home-section-container {
    border: none!important;
    position: relative;
}
.home-section-footer {
    margin-top: auto;
    position: absolute;
    bottom: 1rem;
}
</style>
